import { Observable } from 'rxjs';
import {
  CanDeactivate,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DialogService,
  DialogConfig,
  DialogSize
} from '@tmhcc-ng-lib/framwork/dialog';
import { DialogContainerComponent } from './DialogContainer/dialog-container.component';
import { Messages } from '@tmhcc-ng-lib/models';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';

export interface ComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class SaveChangeGaurd implements CanDeactivate<ComponentDeactivate> {
  formGroup: FormGroup;
  hideHeader: boolean;
  hideFooter: boolean;
  hideSave: boolean;
  hideHeaderX: boolean;
  titleText: string;
  navigationUrl: string;

  constructor(
    private dialogService: DialogService,
    private dialogConfig: DialogConfig,
    public router: Router,
    public loaderService: LoaderService
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.navigationUrl = event.url;
      }
      if (event instanceof NavigationError) {
        console.log(event.error);
      }
    });
  }

  canDeactivate() {
    if (this.formGroup && this.formGroup.dirty) {
      return this.DeactivateRoute();
    }
    return true;
  }

  setFormGroup(formGroup: FormGroup) {
    this.formGroup = formGroup;
  }

  DeactivateRoute(): Observable<boolean> | boolean {
    let content = {
      value: Messages.DirtyCheck
    };
    this.dialogConfig.data = content;

    this.dialogConfig.modalSetting = {
      title: this.titleText,
      hideHeader: this.hideHeader,
      hideFooter: true,
      hideSave: this.hideSave,
      hideHeaderX: this.hideHeaderX,
      SaveButton: 'Yes',
      CancelButton: 'No',
      dialogSize: DialogSize.SM
    };
    const ref = this.dialogService.open(
      DialogContainerComponent,
      this.dialogConfig
    );
    ref.afterClosed.subscribe(result => {
      if (result) {
        this.formGroup.markAsPristine();
        this.loaderService.show();
        this.router.navigate([this.navigationUrl]);
      }
    });
    return false;
  }
}
